/* Copy of shrd utils/enums/substitution-manager/SubstitutionFollowUp.ts */
/**
 * "Nachbereitung" of a substitution inquiry whose day is over without a selected substitute and without a completed
 * cancellation (office, 13.10.2026): what really happened. Documentation only – the state of the inquiry, the course
 * segments (payoff) and the statistics stay untouched. Only {@link SubstitutionFollowUpOutcome.CANCELLED} has an effect:
 * the lesson counts as cancelled for the make-up claims (compensation → Nachholansprüche, like a sent cancellation).
 */
export enum SubstitutionFollowUpOutcome {
    /** The lesson did not take place (nobody taught) */
    CANCELLED = 'cancelled',
    /** Somebody substituted without a confirmation in Vanilla */
    SUBSTITUTED = 'substituted',
    /** The absent teacher taught the lesson after all */
    HELD_BY_TEACHER = 'heldByTeacher',
}

export const SUBSTITUTION_FOLLOW_UP_OUTCOME_LABELS: Record<SubstitutionFollowUpOutcome, string> = {
    [SubstitutionFollowUpOutcome.CANCELLED]: 'Stunde ist ausgefallen',
    [SubstitutionFollowUpOutcome.SUBSTITUTED]: 'Wurde vertreten',
    [SubstitutionFollowUpOutcome.HELD_BY_TEACHER]: 'Lehrkraft hat doch selbst unterrichtet',
};

/** Max. length of the office note of the Nachbereitung */
export const SUBSTITUTION_FOLLOW_UP_NOTE_MAX_LENGTH = 500;
